import { useLanguage } from "../context/LanguageContext";

export default function RouteFallback() {
  const { t } = useLanguage();
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 14, color: "rgba(var(--c-on-bg),0.35)" }}>
        {t("common.loading")}
      </div>
    </div>
  );
}
